import heroImg from './hero-img.png'
import instagram from './instagram.svg'
import siteLogo from './site-logo.png'
import telegram from './telegram.svg'
import timelineCircle from './timeline-circle.png'
import twitter from './twitter.svg'

export default { heroImg, instagram, siteLogo, telegram, timelineCircle, twitter }
